import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Dialog } from '@core/models/dialog.interface';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import Messages from '@core/utils/functions/messages.function';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService {

  constructor(private base: BaseService, private _messages: Messages, ) { }

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk .+ failed/;
    // console.log(error);
    if (chunkFailedMessage.test(error)) {
      let data: Dialog = {
        icon: {
          name: faCircleCheck,
          container: 'bg-warning color-warning',
        },
        title: 'The application has been updated and you are browsing an older version, we will refresh the page so you can continue.',
        confirmButton: { text: 'Ok', icon: faCircleCheck },
        padding: '3rem 1.5rem 1.5rem',
        data: {}
      }
        this._messages.showMessage(data).subscribe({
        next: (response) => {
          window.location.reload();
        }
      });
    }
  } 

}
